import type { RouteRecord } from "vite-react-ssg";

import Index from "./pages/Index";
import Services from "./pages/Services";
import About from "./pages/About";
import PaverPatios from "./pages/masonry/PaverPatios";
import RetainingWalls from "./pages/masonry/RetainingWalls";
import StepsStoops from "./pages/masonry/StepsStoops";
import OutdoorKitchens from "./pages/masonry/OutdoorKitchens";
import FireplacesFirepits from "./pages/masonry/FireplacesFirepits";
import FireplaceInstallation from "./pages/masonry/FireplaceInstallation";
import StoneVeneer from "./pages/masonry/StoneVeneer";
import MasonryRepair from "./pages/masonry/Repair";

import PaverPatioRepair from "./pages/masonry/PaverPatioRepair";
import PaverWalkways from "./pages/masonry/PaverWalkways";
import PaverDriveways from "./pages/masonry/PaverDriveways";
import RetainingWallRepair from "./pages/masonry/RetainingWallRepair";
import StoneMasonryInstallation from "./pages/masonry/StoneMasonryInstallation";
import StoneMasonryRepair from "./pages/masonry/StoneMasonryRepair";
import CustomMasonry from "./pages/masonry/CustomMasonry";
import BrickWork from "./pages/masonry/BrickWork";
import BlockWork from "./pages/masonry/BlockWork";
import CommercialMasonry from "./pages/masonry/CommercialMasonry";
import PavingServices from "./pages/PavingServices";
import ConcreteServices from "./pages/ConcreteServices";
import ConcretePatios from "./pages/concrete/Patios";
import ConcreteDriveways from "./pages/concrete/Driveways";
import ConcreteSidewalks from "./pages/concrete/Sidewalks";
import StampedConcrete from "./pages/concrete/StampedConcrete";
import ConcreteRepair from "./pages/concrete/Repair";
import ConcreteFoundationRepair from "./pages/concrete/FoundationRepair";
import ConcreteFoundations from "./pages/concrete/Foundations";
import ConcreteFootings from "./pages/concrete/Footings";
import WaterproofingServices from "./pages/WaterproofingServices";
import BasementWaterproofing from "./pages/waterproofing/BasementWaterproofing";
import PatioWaterproofing from "./pages/waterproofing/PatioWaterproofing";
import ServiceAreas from "./pages/ServiceAreas";

import PassaicCounty from "./pages/locations/PassaicCounty";
import BergenCounty from "./pages/locations/BergenCounty";
import EssexCounty from "./pages/locations/EssexCounty";
import MorrisCounty from "./pages/locations/MorrisCounty";
import Clifton from "./pages/locations/Clifton";
import PassaicCity from "./pages/locations/Passaic";
import PaverPatioPenningtonPark from "./pages/locations/PaverPatioPenningtonPark";
import PaverPatioDowntownPaterson from "./pages/locations/PaverPatioDowntownPaterson";
import FAQ from "./pages/FAQ";
import Gallery from "./pages/Gallery";
import Reviews from "./pages/Reviews";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import DataRequest from "./pages/DataRequest";
import ProTips from "./pages/ProTips";
import ChoosingProfessionalMasonryCompany from "./pages/pro-tips/ChoosingProfessionalMasonryCompany";
import BenefitsOfPaverPatio from "./pages/pro-tips/BenefitsOfPaverPatio";
import WhatIsAStoop from "./pages/pro-tips/WhatIsAStoop";
import PaverPatioCostNorthJersey from "./pages/pro-tips/PaverPatioCostNorthJersey";
import LPPaverPatios from "./pages/lp/PaverPatios";
import LPRetainingWalls from "./pages/lp/RetainingWalls";
import Financing from "./pages/Financing";
import Packages from "./pages/Packages";
import BackyardPromo from "./pages/BackyardPromo";
import BackyardBundleThankYou from "./pages/BackyardBundleThankYou";
import VideosHub from "./pages/VideosHub";
import { WatchPage } from "./components/WatchPage";
import { WATCH_PAGES } from "./data/watchPages";

export const routes: RouteRecord[] = [
  { index: true, Component: Index },
  { path: "services", Component: Services },
  { path: "about", Component: About },

  // Masonry Services
  { path: "paving-services/paver-patios", Component: PaverPatios },
  { path: "masonry-services/retaining-walls", Component: RetainingWalls },
  { path: "masonry-services/steps-stoops", Component: StepsStoops },
  { path: "masonry-services/outdoor-kitchens", Component: OutdoorKitchens },
  { path: "masonry-services/fire-pits", Component: FireplacesFirepits },
  { path: "masonry-services/fireplace-installation", Component: FireplaceInstallation },
  { path: "masonry-services/stone-veneer", Component: StoneVeneer },
  { path: "masonry-services/steps-stoops-repair", Component: MasonryRepair },
  
  { path: "paving-services/paver-patio-repair", Component: PaverPatioRepair },
  { path: "paving-services/paver-walkways", Component: PaverWalkways },
  { path: "paving-services/paver-driveways", Component: PaverDriveways },
  { path: "masonry-services/retaining-wall-repair", Component: RetainingWallRepair },
  { path: "masonry-services/stone-masonry", Component: StoneMasonryInstallation },
  { path: "masonry-services/stone-masonry-repair", Component: StoneMasonryRepair },
  { path: "masonry-services/custom-masonry", Component: CustomMasonry },
  { path: "masonry-services/brick-work", Component: BrickWork },
  { path: "masonry-services/block-work", Component: BlockWork },
  { path: "masonry-services/commercial-masonry", Component: CommercialMasonry },

  // Paving
  { path: "paving-services", Component: PavingServices },

  // Concrete Services
  { path: "concrete-services", Component: ConcreteServices },
  { path: "concrete-services/patios", Component: ConcretePatios },
  { path: "concrete-services/driveways", Component: ConcreteDriveways },
  { path: "concrete-services/sidewalks", Component: ConcreteSidewalks },
  { path: "concrete-services/stamped-concrete", Component: StampedConcrete },
  { path: "concrete-services/repair", Component: ConcreteRepair },
  { path: "concrete-services/foundation-repair", Component: ConcreteFoundationRepair },
  { path: "concrete-services/foundations", Component: ConcreteFoundations },
  { path: "concrete-services/footings", Component: ConcreteFootings },

  // Waterproofing
  { path: "waterproofing-services", Component: WaterproofingServices },
  { path: "waterproofing-services/basement-waterproofing", Component: BasementWaterproofing },
  { path: "waterproofing-services/patio-waterproofing", Component: PatioWaterproofing },

  // Service Areas
  { path: "service-areas", Component: ServiceAreas },
  
  { path: "service-areas/passaic-county", Component: PassaicCounty },
  { path: "service-areas/bergen-county", Component: BergenCounty },
  { path: "service-areas/essex-county", Component: EssexCounty },
  { path: "service-areas/morris-county", Component: MorrisCounty },
  { path: "service-areas/passaic-county/clifton", Component: Clifton },
  { path: "service-areas/passaic-county/passaic", Component: PassaicCity },
  { path: "service-areas/passaic-county/paver-patio-pennington-park-paterson", Component: PaverPatioPenningtonPark },
  { path: "service-areas/passaic-county/paver-patio-downtown-paterson", Component: PaverPatioDowntownPaterson },

  // Other pages
  { path: "faq", Component: FAQ },
  { path: "gallery", Component: Gallery },
  { path: "videos", Component: VideosHub },
  ...WATCH_PAGES.map((p) => ({ path: `videos/${p.slug}`, element: <WatchPage slug={p.slug} /> })),
  { path: "reviews", Component: Reviews },
  { path: "contact", Component: Contact },
  { path: "privacy-policy", Component: PrivacyPolicy },
  { path: "terms-and-conditions", Component: TermsAndConditions },
  { path: "data-request", Component: DataRequest },

  // Financing
  { path: "financing", Component: Financing },

  // Packages
  { path: "packages", Component: Packages },

  // Pro Tips
  { path: "pro-tips", Component: ProTips },
  { path: "pro-tips/choosing-a-professional-masonry-company", Component: ChoosingProfessionalMasonryCompany },
  { path: "pro-tips/benefits-of-adding-a-paver-patio", Component: BenefitsOfPaverPatio },
  { path: "pro-tips/what-is-a-stoop", Component: WhatIsAStoop },
  { path: "pro-tips/paver-patio-cost-north-jersey", Component: PaverPatioCostNorthJersey },

  // Landing pages
  { path: "lp/paver-patios", Component: LPPaverPatios },
  { path: "lp/retaining-walls", Component: LPRetainingWalls },
  { path: "lp/backyard-bundle", Component: BackyardPromo },
  { path: "lp/backyard-bundle/thank-you", Component: BackyardBundleThankYou },
];
